/**
 * @module store/emails/actions
 *
 * @version 1.0.2
 * @copyright SBC 2019
 */


import { Auth } from 'aws-amplify';


import {
  apiGetStartsOrganizers,
  apiSetStartsOrganizer,
  apiDeleteStartsOrganizers,
  apiGetSystemOrganizer,
} from '@/api';
import * as types from '@/store/mutation-types';

/**
 * Action: Получеие страницы с организаторами стартов
 *
 * @since Version 1.0.0
 */
const getStartsOrganizers = async ({ commit, rootGetters }, { limit, offset }) => {
  commit(types.GET_STARTS_ORGANIZERS_ASYNC.PENDING);
  try {
    if (rootGetters['user/isLoggin']) {
      const user = rootGetters['user/user'];
      const userSession = await Auth.userSession(user);

      const { data, total } = await apiGetStartsOrganizers(userSession.accessToken.jwtToken, { limit, offset });

      commit(types.GET_STARTS_ORGANIZERS_ASYNC.SUCCESS, {
        data,
        total,
      });
    } else {
      throw new Error('401 Unauthorized');
    }
  } catch (error) {
    console.log(error);
    commit(types.GET_STARTS_ORGANIZERS_ASYNC.FAILURE);
  }
};


/**
 * Action: Set starts organizer
 *
 * @since Version 1.0.3
 */
const setStartsOrganizer = async ({ rootGetters }, startsOrganizer) => {
  try {
    if (rootGetters['user/isLoggin']) {
      const user = rootGetters['user/user'];
      const userSession = await Auth.userSession(user);

      await apiSetStartsOrganizer(userSession.accessToken.jwtToken, startsOrganizer);
    } else {
      throw new Error('401 Unauthorized');
    }
  } catch (error) {
    console.log(error);
    return { error };
  }
  return 0;
};


/**
 * Action: Delete starts organizers
 *
 * @since Version 1.0.2
 */
const deleteStartsOrganizers = async ({ rootGetters }, startsOrganizers) => {
  try {
    if (rootGetters['user/isLoggin']) {
      const user = rootGetters['user/user'];
      const userSession = await Auth.userSession(user);

      await apiDeleteStartsOrganizers(userSession.accessToken.jwtToken, startsOrganizers);
    } else {
      throw new Error('401 Unauthorized');
    }
  } catch (error) {
    console.log(error);
  }
};


/**
 * Action: Get own organizer
 *
 * @since Version 1.0.2
 */
const getSystemOrganizer = async ({ commit, rootGetters }) => {
  try {
    if (rootGetters['user/isLoggin']) {
      const user = rootGetters['user/user'];
      const userSession = await Auth.userSession(user);

      const { data } = await apiGetSystemOrganizer(userSession.accessToken.jwtToken);

      commit(types.GET_SYSTEM_START_ORGANIZER_ASYNC.SUCCESS, data);
    } else {
      throw new Error('401 Unauthorized');
    }
  } catch (error) {
    console.log(error);
  }
};

export default {
  deleteStartsOrganizers,
  getStartsOrganizers,
  setStartsOrganizer,
  getSystemOrganizer,
};
